const quickSearch = () => {

	const hdrSearchBlock = document.querySelector('[data-form="hdr-search"]'),	
		  hdrSearchInput = document.querySelector('[data-form="hdr-search"] .input');

	try {
		let requestTimer;

		hdrSearchInput.addEventListener('input', ()=>{

			if(hdrSearchInput.value.length > 2) {

				clearTimeout(requestTimer);

				requestTimer = setTimeout(function(){
					sendRequest();
				  }, 1000);

				addEventListener('click', closeModalSearch);
			
				// получаем json

				let requestLink = `/local/templates/schmetz/ajax/search.php?q=${hdrSearchInput.value}`;

				// console.log(requestLink)
				
				function sendRequest() {

					let oldBlock = hdrSearchBlock.querySelector('.hdr-quick-search');

			    	if(oldBlock) {
			    		oldBlock.remove();
			    	}
					// тест

					let searchHtml;

					window.fetch(requestLink)
					  .then((response) => {
					    return response.json();
					  })
					  .then((data) => {
					    console.log(data);
					    searchHtml = data;

					    if(searchHtml.ITEMS[0]) {

					    	// формируем пасадочный контейнер
							let searchBlockWrap = hdrSearchBlock.querySelector('.hdr-quick-search'),
								searchBlock 	= document.createElement('div'),
								searchList  	= document.createElement('div');

							searchBlock.classList.add('hdr-quick-search');
							searchList.classList.add('hdr-quick-search-list');

							if(!searchBlockWrap) {
								hdrSearchBlock.appendChild(searchBlock);
								searchBlock.appendChild(searchList);
							}
							//END формируем пасадочный контейнер

							
							
							// заполняем контейнер со списком товаров
							for (let key in searchHtml.ITEMS) {

								searchList.innerHTML = searchList.innerHTML + `

									<a href="${searchHtml.ITEMS[key].URL}" class="link-item">
										<span class="title">${searchHtml.ITEMS[key].NAME}</span>
										<div class="price-wrap">
											<span class="old-price">${searchHtml.ITEMS[key].PRICE_OLD}</span>
											<span class="current-price">${searchHtml.ITEMS[key].PRICE}</span>
										</div>
									</a>

								`;
							}
							//END заполняем контейнер со списком товаров


							// пихаем ссылку на все товары
							searchBlock.innerHTML = searchBlock.innerHTML + `

								<a href="#" class="show-all" data-btn="show-all">Показать все результаты</a>

							`;

							let showAllBtn = searchBlock.querySelector('[data-btn="show-all"]');

							showAllBtn.addEventListener('click', (e) => {
								e.preventDefault();

								showAllBtn.closest('.hdr-search').submit();
							});
							//END пихаем ссылку на все товары
					    } else {
					    	let oldBlock = hdrSearchBlock.querySelector('.hdr-quick-search');

					    	if(oldBlock) {
					    		oldBlock.remove();
					    	}

					    	// формируем пасадочный контейнер
							let searchBlockWrap = hdrSearchBlock.querySelector('.hdr-quick-search'),
								searchBlock 	= document.createElement('div'),
								searchList  	= document.createElement('div');

							searchBlock.classList.add('hdr-quick-search');
							searchList.classList.add('hdr-quick-search-list');

							if(!searchBlockWrap) {
								hdrSearchBlock.appendChild(searchBlock);
								searchBlock.appendChild(searchList);
							}
							//END формируем пасадочный контейнер

							searchList.innerHTML = `
								<div class="link-item">
									<span class="bold">Ничего не найдено...</span>
								</div>
							`;
					    }

						


					  });

					
				}
			} else {
				let quickSearchModal = hdrSearchBlock.querySelector('.hdr-quick-search');
				if(quickSearchModal) {
					hdrSearchBlock.removeChild(quickSearchModal);
					removeEventListener('click', closeModalSearch);
				}
			}
		});
	} catch(e){}
	// закрыть вне элемента
	function closeModalSearch(e) {
		let target = e.target;

		let quickSearchModal = hdrSearchBlock.querySelector('.hdr-quick-search');

		if(!hdrSearchBlock.contains(target)) {
			hdrSearchBlock.removeChild(quickSearchModal);

			removeEventListener('click', closeModalSearch);
		}

		// console.log('qwe')
	}


};

export default quickSearch;